import { z } from "zod";

const emailSchema = z.string().email();

export function normalizeEmail(value) {
  if (typeof value !== "string") return "";
  return value.trim().toLowerCase();
}

export function isValidEmail(value) {
  if (typeof value !== "string") return false;
  return emailSchema.safeParse(normalizeEmail(value)).success;
}
